
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import {
  CHART_TIME_TYPE_CURRENT_MONTH,
  CHART_TIME_TYPE_OPTIONS
} from '@/const/ChartTimeType';

@Component({
  name: 'WorkMenuList',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: {}
  })
  layout!: {};

  @Prop({
    type: Boolean,
    default: true
  })
  isDraggable!: Boolean
   @Prop({
     default: () => {}
   })
  layoutData!: any

  @Watch('layoutData', {
    deep: true,
    immediate: true
  })
   change() {
     this.dealData();
   }
   @Watch('layout', {
     deep: true,
     immediate: true
   })
  changeLayout() {
    this.dealData();
  }
  private isHaveBranch=false

  private myChartsLine: any = null;
  private myChartsBar: any = null;
  private myChartsPie: any = null;

  private orderData:any={};
  private toDoData:any={};
  private branchCompanyRankingData:any=[];
  private serviceCompanyStatistics:any=[];
  private orderCheckData:any={};
  private orderBBSData:any={};
  private linechart = {
    id: CHART_TIME_TYPE_CURRENT_MONTH,
    name: '当月'
  }
  private linechartOptions: any = CHART_TIME_TYPE_OPTIONS;
  private cycleCheckData:any={};
  private companyVersionData:any={};

  private dayList:any=[
    { id: 1,
      name: '当日'
    },
    { id: 2,
      name: '当周'
    },
    { id: 3,
      name: '当月'
    },
    { id: 4,
      name: '当年'
    }
  ]

  private top6Data={
    id: 1,
    name: '当日'
  }
  private serverStatisticData={
    id: 1,
    name: '当日'
  }
  private isTitleToggle: any = 0
  private userName:string=UserModule.getUserName
  private getDivision(val:any) {
    let aa = '0.00%';
    if (parseInt(val.all_order_num) !== 0) {
      aa = (parseInt(val.finish_order_num) / parseInt(val.all_order_num) * 100).toFixed(2) + '%';
    }
    return aa;
  }
  private getVersionData(val:any) {
    let aa:any = 0;
    aa = (parseInt(val) - parseInt(String(new Date().getTime() / 1000))) / 3600 / 24;
    return parseInt(aa);
  }

  private echartsDataLine() {
    let option = {
      color: ['#8DB9FC', '#18CA9B', '#BB89FB'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        data: [
          '进行中',
          '已完成',
          '全部'
        ],
        left: 'left',
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 30,
        icon: 'circle',
        lineStyle: {
          width: 0
        },
        textStyle: {
          fontSize: 16
        }
      },
      grid: [
        {
          left: 30,
          right: 50,
          containLabel: true
        }
      ],
      toolbox: {
        show: false,
        top: 'bottom',
        feature: {
          dataView: {
            readOnly: false,
            show: true,
            title: '',
            lang: ['数据视图', '关闭', '刷新']
          },
          magicType: {
            title: '',
            type: ['line', 'bar']
          },
          restore: {},
          saveAsImage: {
            title: ''
          }
        },
        iconStyle: {
          borderColor: '#555'
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.orderData.line_char ? this.orderData.line_char.time : []
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '进行中',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(141, 185, 252)'
              },
              {
                offset: 1,
                color: 'rgb(255, 255, 255)'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.underway_order_num : []
        },
        {
          name: '已完成',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(24, 202, 155)'
              },
              {
                offset: 1,
                color: 'rgb(255, 255, 255)'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.finish_order_num : []
        },
        {
          name: '全部',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(187, 137, 251)'
              },
              {
                offset: 1,
                color: '#fff'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.all_order_num : []
        }
      ]
    };
    this.myChartsLine.setOption(option);
    // window.addEventListener('resize', () => {
    //   (document.querySelector('.line-echarts') as any).style.width = '100%';
    //   this.myChartsLine.resize();
    // });
  }

  private echartsDataBar() {
    let option = {
      tooltip: {},
      legend: {
        data: ['已完成', '全部订单'],
        left: '0'
      },
      title: [
        {
          text: '',
          left: 10,
          textAlign: 'left'
        }
      ],
      grid: [
        {
          top: 30,
          width: '90%',
          bottom: 10,
          left: 10,
          containLabel: true
        }
      ],
      xAxis: [
        {
          type: 'value',
          splitLine: {
            show: true
          },
          axisLine: {
            show: false
          },
          axisTick: {
            inside: true,
            lineStyle: {
              width: 0
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          // data: Object.keys(topCompany.charts),
          axisLabel: {
            interval: 0,
            rotate: 30
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#18CA9B',
              width: '2'
            }
          },
          inverse: true
        }
      ],
      series: [
        {
          name: '全部订单',
          type: 'bar',
          barGap: '-100%',
          silent: true,
          itemStyle: {
            color: '#ECECEC'
          },
          barWidth: 20,
          data: this.branchCompanyRankingData ? this.branchCompanyRankingData.map(function(current: any) {
            return current.all_order_num;
          }) : []
        },
        {
          name: '已完成',
          type: 'bar',
          barGap: '-100%',
          itemStyle: {
            color: '#2AC99C'
          },
          // label: {
          //   position: 'right',
          //   show: true
          // },
          barWidth: 20,
          data: this.branchCompanyRankingData ? this.branchCompanyRankingData.map(function(current: any) {
            return current.finish_order_num;
          }) : []
        }
      ]
    };
    option && this.myChartsBar.setOption(option);
    // window.addEventListener('resize', () => {
    //   this.myChartsBar.resize();
    // });
  }

  private echartsDataPie() {
    let piedata:any = [
      { value: this.cycleCheckData.finish_num, name: '已执行' },
      { value: this.cycleCheckData.unfinish_num, name: '未执行' }
    ];

    let option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        itemWidth: 10,
        itemHeight: 10,
        icon: 'circle',
        bottom: 10,
        left: 0,
        itemGap: 30,
        formatter: function(name: any) {
          let data = piedata;
          let target;
          for (let i = 0, l = data.length; i < l; i++) {
            if (data[i].name === name) {
              target = data[i].value;
            }
          }
          return ['{a|' + target + '}', '{b|' + name + '}'].join('\n');
        },
        textStyle: {
          rich: {
            a: {
              color: '#041021',
              fontSize: 30,
              align: 'left',
              padding: [30, 0, 5, 6]
            },
            b: {
              color: '#878E9B',
              fontSize: 18,
              align: 'left',
              padding: [0, 0, 0, 6]
            }
          }
        }
      },
      series: [
        {
          name: '点检执行率',
          type: 'pie',
          center: ['50%', 150],
          radius: ['50%', '65%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            fontSize: '22',
            position: 'center',
            formatter: function(name: any) {
              if (name.name === '已执行') {
                return [name.percent.toFixed(2) + '%', name.seriesName].join('\n');
              } else {
                return [(100 - name.percent).toFixed(2) + '%', name.seriesName].join('\n');
              }
            },
            lineHeight: 30
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '22'
            }
          },
          labelLine: {
            show: false
          },
          data: piedata,

          color: ['#3081EF', 'rgba(48, 129, 239, .2)']

        }
      ]
    };
    option && this.myChartsPie.setOption(option);
    // window.addEventListener('resize', () => {
    //   this.myChartsPie.resize();
    // });
  }
  private dealData() {
    this.isHaveBranch = checkPermissionCompany(UserModule.getCompanyId, Type.BranchCompany);
    if (this.layoutData) {
      if (this.layoutData.order_information) {
        this.orderData = this.layoutData.order_information;
      }
      if (this.layoutData.unfinish_order_information) {
        this.toDoData = this.layoutData.unfinish_order_information;
      }
      if (this.layoutData.order_information) {
        this.orderData = this.layoutData.order_information;
      }
      if (this.layoutData.branch_company_ranking) {
        this.branchCompanyRankingData = this.layoutData.branch_company_ranking;
      }
      if (this.layoutData.service_company_statistics) {
        this.serviceCompanyStatistics = this.layoutData.service_company_statistics;
      }
      if (this.layoutData.untreated_check_order_information) {
        this.orderCheckData = this.layoutData.untreated_check_order_information;
      }
      if (this.layoutData.order_bbs_information) {
        this.orderBBSData = this.layoutData.order_bbs_information;
      }

      if (this.layoutData.cycle_check_information) {
        this.cycleCheckData = this.layoutData.cycle_check_information;
      }
      if (this.layoutData.company_version_information) {
        this.companyVersionData = this.layoutData.company_version_information;
      }
      if (document.getElementById('line-echarts')) {
        this.myChartsLine = echarts.init((document.getElementById('line-echarts') as any));
        this.echartsDataLine();
      }
      if (document.getElementById('topbar-echarts')) {
        this.myChartsBar = echarts.init((document.getElementById('topbar-echarts') as any));
        this.echartsDataBar();
      }
      if (document.getElementById('pie-echarts')) {
        this.myChartsPie = echarts.init((document.getElementById('pie-echarts') as any));
        this.echartsDataPie();
      }
    }
  }
  private swichOrder(val:any) {
    let pamars = {
      is_branch_company_order: val,
      is_order_information: 1,
      order_information_type: this.linechart.id
    };
    this.isTitleToggle = val;
    this.$emit('pamars', pamars);
  }
  private dayChange(val:any) {
    let pamars = {
      branch_company_type: val.id,
      is_branch_company_ranking: 1
    };
    this.$emit('pamars', pamars);
  }
  private serverStatisticDayChange(val:any) {
    let pamars = {
      service_company_statistics_type: val.id,
      is_service_company_statistics: 1
    };
    this.$emit('pamars', pamars);
  }

  private swichOrderDate(val:any) {
    let pamars = {
      is_branch_company_order: this.isTitleToggle,
      order_information_type: val.id,
      is_order_information: 1
    };
    this.$emit('pamars', pamars);
  }
  private toChage() {
    this.$alert('', '请联系报修管家。联系电话：010-62111361', {
      confirmButtonText: '我知道了',
      center: true,
      callback: function() {

      }
    });
  }
  private moduleListClick(val:any) {
    if (!this.isDraggable) {
      if (val.jumpUrl) {
        this.$router.push({
          path: val.jumpUrl
        });
      }
    }
  }
  private deleteMenuHandle(val: any) {
    this.$emit('deleteMenu', val);
  }
  private isFinishedAscending:number = 0
  private isClosedAscending: number = 0
  private isResponseAscending: number = 0
  private isRepairAscending: number = 0
  private finishedUp() {
    this.isFinishedAscending = 1;
    this.isClosedAscending = 0;
    this.isResponseAscending = 0;
    this.isRepairAscending = 0;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'finish_order_num',
      service_company_statistics_sort_rule: 0
    };
    this.$emit('pamars', pamars);
  }
  private finishedDown() {
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'finish_order_num',
      service_company_statistics_sort_rule: 1
    };
    this.$emit('pamars', pamars);
    this.isFinishedAscending = 2;
    this.isClosedAscending = 0;
    this.isResponseAscending = 0;
    this.isRepairAscending = 0;
  }

  private closedUp() {
    this.isResponseAscending = 0;
    this.isRepairAscending = 0;
    this.isFinishedAscending = 0;
    this.isClosedAscending = 1;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'close_order_num',
      service_company_statistics_sort_rule: 0
    };
    this.$emit('pamars', pamars);
  }
  private closedDown() {
    this.isResponseAscending = 0;
    this.isRepairAscending = 0;
    this.isFinishedAscending = 0;
    this.isClosedAscending = 2;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'close_order_num',
      service_company_statistics_sort_rule: 1
    };
    this.$emit('pamars', pamars);
  }

  private responseUp() {
    this.isRepairAscending = 0;
    this.isFinishedAscending = 0;
    this.isClosedAscending = 0;
    this.isResponseAscending = 1;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'avg_response_time',
      service_company_statistics_sort_rule: 0
    };
    this.$emit('pamars', pamars);
  }
  private responseDown() {
    this.isRepairAscending = 0;
    this.isFinishedAscending = 0;
    this.isClosedAscending = 0;
    this.isResponseAscending = 2;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'avg_response_time',
      service_company_statistics_sort_rule: 1
    };
    this.$emit('pamars', pamars);
  }

  private repairUp() {
    this.isFinishedAscending = 0;
    this.isClosedAscending = 0;
    this.isResponseAscending = 0;
    this.isRepairAscending = 1;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'avg_repair_time',
      service_company_statistics_sort_rule: 0
    };
    this.$emit('pamars', pamars);
  }
  private repairDown() {
    this.isFinishedAscending = 0;
    this.isClosedAscending = 0;
    this.isResponseAscending = 0;
    this.isRepairAscending = 2;
    let pamars = {
      service_company_statistics_type: this.serverStatisticData.id,
      is_service_company_statistics: 1,
      service_company_statistics_sort_field: 'avg_repair_time',
      service_company_statistics_sort_rule: 1
    };
    this.$emit('pamars', pamars);
  }
  private jumpBBs(bbs:any) {
    let routeData = this.$router.resolve({
      path: '/order/orderToDetail',
      query: {
        order_service_id: bbs.order_service_id,
        orderId: bbs.order_id,
        isCheckOrder: '1',
        showComplaintBtn: '1',
      }
    });
    window.open(routeData.href);
  }
  private bbsAll() {
    this.$router.push({
      path: '/Record/bbs',
      query:{
        enterType:'1'
      }
    })
  }
}
